'use strict';

module.exports = function( key, value ) {
	var obj = {};
	obj[ key ] = value;
	return obj;
};
